"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceRecent = exports.clearRecent = exports.removeRecent = exports.setRecentSearchList = exports.getRecentSearchList = void 0;
function getRecentSearchList() {
    let recentList = JSON.parse(localStorage.getItem("recentSearch") || "[]");
    if (recentList.find((recent) => recent.query)) {
        recentList = (0, exports.replaceRecent)();
    }
    return recentList;
}
exports.getRecentSearchList = getRecentSearchList;
function setRecentSearchList(item, setRecent) {
    // 검색어만 저장 하는 경우
    if (item.type === "query") {
        if (item.content === "")
            return;
        const recentList = JSON.parse(localStorage.getItem("recentSearch") || "[]");
        const removedList = recentList.filter((recentItem) => recentItem.content !== item.content);
        const newList = removedList
            .concat([
            {
                type: "query",
                content: item.content,
                time: new Date().toISOString(),
                query: item.content,
            },
        ])
            .sort((a, b) => new Date(b.time).getTime() -
            new Date(a.time).getTime())
            .slice(0, 30);
        localStorage.setItem("recentSearch", JSON.stringify(newList));
        setRecent(newList);
    }
    // 자동완성된거 타고갈때
    if (item.type === "location") {
        const recentList = JSON.parse(localStorage.getItem("recentSearch") || "[]");
        const locationContent = item.content;
        const removedList = recentList.filter((recentItem) => {
            const isEqual = recentItem.query !== item.query;
            return isEqual;
        });
        const newList = removedList
            .concat([
            {
                type: "location",
                content: locationContent,
                time: new Date().toISOString(),
                query: locationContent.main_name
                    ? locationContent.main_name +
                        (locationContent.branch ? " " + locationContent.branch : "")
                    : "",
                branch: locationContent.branch,
            },
        ])
            .sort((a, b) => new Date(b.time).getTime() -
            new Date(a.time).getTime())
            .slice(0, 30);
        localStorage.setItem("recentSearch", JSON.stringify(newList));
        setRecent(newList);
    }
}
exports.setRecentSearchList = setRecentSearchList;
function removeRecent(item, setRecent) {
    const recentList = JSON.parse(localStorage.getItem("recentSearch") || "[]");
    const removedList = recentList.filter((recentItem) => recentItem.query !== item.query);
    localStorage.setItem("recentSearch", JSON.stringify(removedList));
    setRecent(removedList);
}
exports.removeRecent = removeRecent;
function clearRecent(setRecentList) {
    localStorage.setItem("recentSearch", "[]");
    setRecentList([]);
}
exports.clearRecent = clearRecent;
const replaceRecent = () => {
    const recentList = JSON.parse(localStorage.getItem("recentSearch") || "[]");
    const replacedList = recentList.map((recent, idx) => {
        if (recent.type === "location") {
            const locationContent = recent.content;
            return {
                type: "location",
                content: locationContent
                    ? locationContent
                    : recent.query
                        ? recent.query
                        : "",
                time: recent.time,
                query: recent.query ? recent.query : "",
            };
        }
        if (recent.type === "query") {
            return {
                type: "query",
                content: recent.query ? recent.query : "",
                time: recent.time,
                query: recent.query ? recent.query : "",
            };
        }
        if (recent.query) {
            return {
                type: "query",
                content: recent.query ? recent.query : "",
                time: recent.time,
                query: recent.query ? recent.query : "",
            };
        }
        return {
            type: "query",
            content: recent.query ? recent.query : "",
            time: recent.time,
            query: recent.query ? recent.query : "",
        };
    });
    localStorage.setItem("recentSearch", JSON.stringify(replacedList));
    return replacedList;
};
exports.replaceRecent = replaceRecent;
